import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useFormikContext } from 'formik';

import { createPopper } from '@popperjs/core';
import { ErrorMsg } from './input/components/error-msg';
import { Label, Root } from './input/input.styles';
import {
    TFormikErrorWrapper,
    TFormikInputLabel,
    TGenericHTMLCompInterface,
} from './types';

const FormikErrorWrapper = <A extends TGenericHTMLCompInterface>({
    meta,
    errorPos,
    label,
    labelPos,
    children,
    ...rest
}: React.PropsWithChildren<TFormikInputLabel & TFormikErrorWrapper<A>>) => {
    const refInput = useRef<A>(null);
    const refError = useRef<HTMLDivElement>(null);
    const [isError, setIsError] = useState<boolean>(false);
    const form = useFormikContext();

    const { error, touched } = meta || {};

    useLayoutEffect(() => {
        if (refError?.current && refInput?.current && touched && error) {
            createPopper(refInput.current, refError.current, {
                placement: errorPos ?? 'right',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 5],
                        },
                    },
                ],
            });
        }
    });

    useEffect(() => {
        if (touched && error) {
            setIsError(true);
        } else {
            setIsError(false);
        }
    }, [error, touched]);

    return (
        <Root labelPos={labelPos}>
            {label ? <Label date-id={'label'}>{label}</Label> : null}
            {(React.isValidElement(children) &&
                React.cloneElement(children, {
                    ...children.props,
                    ...rest,
                    myRef: refInput,
                    isValidating: form.isValidating,
                    isError: isError,
                })) ||
                null}
            {touched && error ? (
                <ErrorMsg myRef={refError}>{error}</ErrorMsg>
            ) : null}
        </Root>
    );
};

export default FormikErrorWrapper;
